import defaultRestApi from "../common/RestApiInstance";
import APIS from "../common/APIs";
import querystring from 'query-string';

export default class LiveCasinoService {
  /**
   * Get AG live casino games service
   */
  static getLiveCasinoGamesAPI = (casinoFilter) => {
    return defaultRestApi.get(APIS.getLiveCasinoGames(querystring.stringify(casinoFilter)),
    {
      headers: {
        "Content-Type": "application/json; charset=UTF-8"
      }
    })
  }
}


// WEBPACK FOOTER //
// ./src/app/services/LiveCasinoService.js